import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Chapter } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { BookActions } from '../book/book.actions';
import { mapChapter } from './chapter.functions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const CHAPTER_FEATURE_KEY: string = 'chapter';

// eslint-disable-next-line
export interface ChapterState extends EntityState<Chapter> {}

function sortByPosition(a: Chapter, b: Chapter): number {
  return a.position - b.position;
}

export const chapterAdapter: EntityAdapter<Chapter> =
  createEntityAdapter<Chapter>({
    sortComparer: sortByPosition,
  });

export const initialChapterState: ChapterState = chapterAdapter.getInitialState(
  {},
);

const reducer: ActionReducer<ChapterState, Action> = createReducer(
  initialChapterState,
  on(AuthActions.logoutSuccess, (): ChapterState => initialChapterState),
  on(
    BookActions.getBookSuccess,
    (state, action): ChapterState =>
      chapterAdapter.upsertMany(
        action.book.chapters.map((chapterDto) =>
          mapChapter(chapterDto, action.book.id),
        ),
        {
          ...state,
        },
      ),
  ),
);

export function chapterReducer(
  state: ChapterState | undefined,
  action: Action,
): ChapterState {
  return reducer(state, action);
}
